export default {
  videoFile: {
    rePlayVideoBtn: 'Replay',
    playVideoBtn: 'Play Video',
    stopVideoBtn: 'Stop Video',
  },
  videoLoop: {
    loopNumber: 'Cycles',
    playEndFrame: 'Keep tail frame',
    title: 'Play',
    autoPlay: 'Autoplay',
    autoPlayText: 'autoplay upon open',
    loop: 'Loop',
  },
  videoSound: {
    videoSound: 'Video Sound',
    muteSound: 'Mute',
    title: 'Sound',
  },
  videoEditor: {
    argumentsAreEmpty: 'URL, OnCrop is a must-pass parameter',
  },
}
